import { Link } from "react-router-dom";
import { quickEntries } from "@/mocks/home";

export default function QuickEntries() {
  return (
    <section className="mx-auto -mt-10 max-w-[1280px] px-4 md:px-8">
      <div className="grid grid-cols-2 gap-3 rounded-xl border border-background-200 bg-background-50 p-3 shadow-sm md:grid-cols-4 md:gap-4 md:p-4">
        {quickEntries.map((entry) => (
          <Link
            key={entry.key}
            to={entry.key === "news" ? "/news" : `/category/${entry.key}`}
            className="group flex items-center gap-3 rounded-lg bg-background-100 p-3.5 transition-colors hover:bg-primary-50 md:p-4"
          >
            <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-lg bg-primary-500 text-background-50 transition-colors group-hover:bg-primary-600">
              <i className={`${entry.icon} text-xl`} />
            </span>
            <span className="min-w-0">
              <span className="flex items-center gap-1.5">
                <span className="font-heading text-sm font-bold text-foreground-950">
                  {entry.title}
                </span>
                <i className="ri-arrow-right-up-line text-xs text-primary-500 opacity-0 transition-opacity group-hover:opacity-100" />
              </span>
              <span className="mt-0.5 block truncate text-xs text-foreground-500">
                {entry.desc}
              </span>
              <span className="mt-0.5 block text-[11px] font-medium text-primary-600">
                {entry.count}
              </span>
            </span>
          </Link>
        ))}
      </div>
    </section>
  );
}